import React from "react";
import "./TopHeader.css";


function TopHeader() {
    return(
        <div>
            <p className = "NameTitle" id ="EnirisstHeader"> Τα δεδομένα έχουν συλλεχθεί στο πρόγραμμα <b> ENIRISST</b></p>
        </div>

    );
}

export default TopHeader;